import { useState } from 'react';
import { createPortal } from 'react-dom';

import { useLanguage } from '../LanguageContext';
import QrCode from '../assets/images/oasia_qr_code.png';
import { renderFormattedText } from '../utils/textFormatter';

function QrModal({ onClose }) {
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 cursor-pointer bg-black/85"
      onClick={onClose}
    >
      <div className="relative w-full h-full flex items-center justify-center pointer-events-none">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="absolute right-4 top-4 pointer-events-auto rounded-full px-4 py-2 text-white transition font-semibold text-sm bg-offwhite-bg/25 hover:bg-offwhite-bg/45"
        >
          ✕
        </button>

        <img
          src={QrCode}
          alt="Sentosa QR Code"
          className="max-w-[85%] max-h-[75vh] object-contain shadow-2xl rounded-2xl pointer-events-auto cursor-default"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>,
    document.body,
  );
}

export default function OasiaHeaderNote() {
  const { t } = useLanguage();
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <div className="space-y-3">
      <p className="text-lg text-content-c2">
        {renderFormattedText(t('schedule.locations.sentosa.qr_note'))}
      </p>

      <button
        type="button"
        onClick={() => setIsZoomed(true)}
        className="block w-full cursor-zoom-in focus:outline-none"
        aria-label="View QR code full size"
      >
        <img
          src={QrCode}
          alt="Sentosa QR Code"
          className="w-full object-contain rounded-xl shadow-md hover:shadow-lg transition-shadow"
        />
        <p className="text-sm text-content-c2 italic mt-1 text-center">
          {t('schedule.locations.sentosa.click_to_expand')}
        </p>
      </button>

      {isZoomed && <QrModal onClose={() => setIsZoomed(false)} />}
    </div>
  );
}
